import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Pricing.css';

const TELEGRAM_URL = 'https://t.me/justdisplay';

const pricingOptions = [
  {
    id: 'own-device',
    title: 'Использовать свое устройство',
    description: 'Подойдёт любой сенсорный дисплей',
    image: '/images/pricing/own-device.jpeg',
    price: '30 000 ₽',
    period: 'в месяц',
    highlight: false,
  },
  {
    id: 'portal-se',
    title: 'Portal SE 21.5"',
    description: 'Идеально для мероприятий, легко перевозить',
    image: '/images/pricing/portal-se.jpeg',
    price: '350 000 ₽',
    oldPrice: '600 000 ₽',
    rentPrice: '20 000 ₽/день',
    period: 'покупка или аренда',
    highlight: true,
    badge: 'Новинка',
  },
  {
    id: 'portal-5',
    title: 'Portal 5',
    description: 'Большой экран от 40"',
    image: '/images/pricing/portal-5.jpeg',
    price: 'от 600 000 ₽',
    oldPrice: '800 000 ₽',
    period: 'покупка',
    highlight: false,
  },
];

const Pricing = () => {
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  return (
    <section className="pricing" id="pricing" ref={ref}>
      <motion.div
        className="pricing-container"
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : {}}
        transition={{ duration: 0.8 }}
      >
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Сколько это стоит
        </motion.h2>

        <div className="pricing-grid">
          {pricingOptions.map((option, index) => (
            <motion.div
              key={option.id}
              className={`pricing-card liquid-glass ${option.highlight ? 'highlight' : ''}`}
              initial={{ opacity: 0, y: 50, scale: 0.9 }}
              animate={inView ? { opacity: 1, y: 0, scale: 1 } : {}}
              transition={{
                duration: 0.6,
                delay: 0.4 + index * 0.15,
                ease: [0.6, -0.05, 0.01, 0.99],
              }}
              whileHover={{ scale: option.highlight ? 1.03 : 1.02, y: -8 }}
            >
              {option.badge && (
                <span className="pricing-badge">{option.badge}</span>
              )}

              <div className="pricing-image-wrap">
                <img
                  src={option.image}
                  alt={option.title}
                  className="pricing-image"
                />
              </div>

              <h3 className="pricing-title">{option.title}</h3>
              <p className="pricing-description">{option.description}</p>

              <div className="pricing-price-block">
                {option.oldPrice && (
                  <span className="pricing-old-price">{option.oldPrice}</span>
                )}
                <span className="pricing-price">{option.price}</span>
                {option.rentPrice && (
                  <span className="pricing-rent">
                    или аренда {option.rentPrice}
                  </span>
                )}
                <span className="pricing-period">{option.period}</span>
              </div>

              <a
                href={TELEGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="pricing-button"
              >
                Связаться с нами
              </a>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Pricing;
